import { observable, configure } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';
import { mergeMessages, maxUpdatedTs } from '../lib/conventionCrewMessages';

configure({ enforceActions: 'always' });

class ConventionMessageStore extends LocalModel {
    constructor() {
        super('conventionMessage', {
            namePlural: 'conventionMessages',
            namePluralReal: 'conventionmessages',
            sort: 'createdDate',
            limit: 1000,
            api: {
                search: {
                    url: '/api/conventionmessages/',
                    params: {
                        limit: 1000,
                        sort: 'createdDate',
                    },
                },
                load: {
                    url: '/api/conventionmessages/',
                    params: {},
                },
                save: {
                    url: '/api/conventionmessages/',
                    params: {},
                },
                patch: {
                    url: '/api/conventionmessages/',
                    params: {},
                },
                delete: {
                    url: '/api/conventionmessages/',
                    params: {},
                },
            },
        });
    }

    @observable conventionMessage = {};

    @observable conventionMessages = [];

    // Not observable: which convention the loaded list belongs to.
    loadedConvention = 0;

    async loadForConvention(conventionId, { full = false } = {}) {
        const id = parseInt(conventionId, 10) || 0;
        if (!id) {
            return null;
        }
        const fullLoad = full || id !== this.loadedConvention;
        const since = fullLoad ? 0 : maxUpdatedTs(this.conventionMessages);
        const response = await util.fetchApi('/api/conventionmessages/', { method: 'GET' }, {
            convention: id,
            ...(since > 0 ? { since } : {}),
        });
        if (response?.status === 200) {
            const incoming = response.data || [];
            const merged = fullLoad
                ? mergeMessages([], incoming)
                : mergeMessages(this.conventionMessages, incoming);
            this.loadedConvention = id;
            this.updateKeyValue('conventionMessages', merged);
        }
        return response;
    }

    async sendMessage({ convention, target, stand = 0, fromStand = 0, priority = 0, body }) {
        const response = await util.fetchApi('/api/conventionmessages/', { method: 'POST' }, {
            convention, target, stand, fromStand, priority, body,
        });
        if (response?.status === 201) {
            await this.loadForConvention(convention);
        }
        return response;
    }

    async ackMessage(uuidv4, { convention, stand }) {
        const response = await util.fetchApi(`/api/conventionmessages/${uuidv4}/ack`, { method: 'PATCH' }, { stand });
        if (response?.status === 200) {
            await this.loadForConvention(convention);
        }
        return response;
    }
}

const store = new ConventionMessageStore();

export default store;
